import React from "react"
import SortUpIcon from "src/icons/sortUp.svg"
import SortDownIcon from "src/icons/sortDown.svg"
import classnames from "classnames"
import LoaderBox from "src/components/forms/fragments/LoaderBox"
import EditIcon from "src/icons/edit.svg"
import styles from "./styles.css"

export default ({
  sortOrder,
  groupsCount,
  toggleSortOrder,
  editResources,
  isPlan,
  pending,
}) => {
  const SortIcon = sortOrder === `desc` ? SortUpIcon : SortDownIcon

  const iconClassName = classnames(styles[`sort-icon`], {
    [styles[`sort-icon-active`]]: sortOrder !== `none`,
  })
  return (
    <div className={styles[`sidebar-header`]}>
      <span className={styles[`sidebar-header-title`]}>
        Ресурсы {Number(groupsCount) ? `(${groupsCount})` : ``}
      </span>
      <div className={styles[`icons-wrapper`]}>
        {isPlan && (
          <div onClick={editResources}>
            <EditIcon size="small" className={styles[`edit-icon`]} />
          </div>
        )}
        {!pending ? (
          <div onClick={() => toggleSortOrder(sortOrder)}>
            <SortIcon size="small" className={iconClassName} />
          </div>
        ) : (
          <div className={styles[`loader-wrapper`]}>
            <LoaderBox size="small" color="#2880ff" />
          </div>
        )}
      </div>
    </div>
  )
}
